import ConfirmModal from '../../../components/ConfirmModal'

// The wire value is lowercase ("cash"/"loan", reilm-be/modules/users/flipTemplateFields.js) but
// both bodies below read as a sentence, not a code identifier.
const displayType = (type) => (type ? type.charAt(0).toUpperCase() + type.slice(1) : '')

const proUltimateBody = (type) =>
  `At least one ${type} template is required. Create another ${type} template before deleting this one, or edit this template to better fit your strategy.`

const starterBody = (type) =>
  `At least one ${type} template is required. Your Starter plan supports one Cash and one Loan template, so this template must remain. You can edit it to better fit your strategy.`

// Gate for S9.3's two audience bodies. Schema enum is only starter/pro (reilm-be/modules/users/
// model.js), default "starter", and signup sets status "trialing" -- so a trialing user carries
// tier "starter" by construction, not by purchase. The Starter body asserts a paid-plan limit
// ("Your Starter plan supports..."), so it must only fire for a real, paid Starter subscription;
// every other case (pro, trialing, absent/unknown tier or status) gets the tier-neutral Pro/Ultimate
// body, which reads true regardless of plan. See README.md ("the tier gate") for the full reasoning.
export function isStarterTier(user) {
  const sub = user?.subscription
  return sub?.tier === 'starter' && Boolean(sub?.status) && sub.status !== 'trialing'
}

// Modal 4, "Template can't be deleted" (mr-6 spec S9.3) -- shown when the DELETE call itself is
// refused by the server-side floor guard (S15 decision 6), not by the client-side disabled trash
// icon alone. Geometry: Pro/Ultimate-error-popup and Starter-error-popup, both 364 x 260.
const ERROR_POPUP_FRAME = { minHeight: 260, padX: 32, padTop: 49, padBottom: 40, titleSize: 18, titleLeading: 22, titleGap: 13, buttonWidth: 96 }

export default function DeleteBlockedModal({ open, templateType, user, onClose }) {
  const type = displayType(templateType)
  const body = isStarterTier(user) ? starterBody(type) : proUltimateBody(type)
  return (
    <ConfirmModal
      open={open}
      onClose={onClose}
      onConfirm={onClose}
      title="Template can't be deleted"
      body={body}
      confirmLabel="Close"
      confirmClassName="bg-[#4AA52A] hover:bg-[#328C12]"
      width={364}
      panelBg="#F4FAEF"
      frame={ERROR_POPUP_FRAME}
    />
  )
}
